export default __webpack_public_path__ + "static/media/BannerMobile.1e100680.jpg";